import React from "react";
import HealthAlertEventDefinitionForm from "./HealthAlertEventDefinitionForm";
const HealthAlertEventDefinitionFormContainer = ({ eventDefinition, onChange }) => /* @__PURE__ */ React.createElement(
  HealthAlertEventDefinitionForm,
  {
    eventDefinition,
    onChange
  }
);
export default HealthAlertEventDefinitionFormContainer;
